import classNames from "classnames/bind";
import styles from "./ConfigZone.module.css";
import { useContext, useEffect, useState } from "react";
import { Alert, Button, Loading, Toast } from "../../../../../components";
import { aiConfigFRS } from "../../../../../services/api/aiConfigFRS";
import { getPolygon, getRoiList, validatorDataIsNumber } from "../../../../../utils";
import CanvasDraw from "./CanvasDraw";
// import axiosClient from "../../../../../services/axiosClient";
import { streamFSR } from "../../../../../services/api/streamFSR";
import { useTranslation } from "react-i18next";
// import { LisencePlateManagerContext } from "../../../../../contexts";

const cx = classNames.bind(styles)

const ConfigZone = ({ cameraCode, ...props }) => {
    // const { cameraCode } = useContext(LisencePlateManagerContext);
    const { onClose, motionStatus, handleTurnOnMotion, companyOfCam } = props;
    const [listPolygon, setListPolygon] = useState({
        polygon1: [],
        polygon2: [],
        polygon3: []
    })
    const [path, setPath] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [cropRegion, setCropRegion] = useState(0);
    const [defaultShape, setDefaultShape] = useState();
    const [reFresh, setRefresh] = useState(false);
    const [confirmDefault, setConfirmDefault] = useState(false);
    const { t } = useTranslation();
    let width = 491;
    let height = 279;
    const getConfigRoi = async () => {
        try {
            const res = await aiConfigFRS.getListAiConfigRoiListByIdCamera(cameraCode)
            if (res && res[0]) {
                const valueConfig = res[0];
                // chuyển từ Json về mảng
                const roilist = valueConfig?.roiList ? getRoiList(valueConfig?.roiList) : [];
                const cropRegion = valueConfig?.cropRegion ? getRoiList(valueConfig?.cropRegion) : [];
                const { polygon1, polygon2, polygon3 } = getPolygon([roilist], width, height);
                setListPolygon({ polygon1, polygon2, polygon3 })
                if (cropRegion?.length > 0) {
                    const crop = cropRegion[0][0] / 100;
                    setCropRegion(crop);
                }
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            // console.log(error);
            Toast.open("Lấy cấu hình không thành công", "danger")
        }
    }
    const getPathStreaming = async () => {
        try {
            const param = {
                cameraCodes: [cameraCode]
            }
            const res = await streamFSR.postListCodeCam(param)
            if (res && res.stream) {
                setPath(res.stream[0].data[0].PATH);
            }
        } catch (error) {
            Toast.open('Không có hình ảnh', 'danger')
        }
    }
    useEffect(() => {
        getConfigRoi()
        getPathStreaming()
    }, [reFresh, cameraCode])

    const handleUpdate = async (infoPolygon, infoCropRegen) => {
        let { polygon1, polygon2, polygon3 } = infoPolygon;
        let data1 = [];
        if (polygon1.length === 5) {
            polygon1.shift();
            const arr = polygon1.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            })
            data1.push(arr);
        }
        if (polygon2.length === 5) {
            polygon2.shift();
            const arr = polygon2.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            })
            data1.push(arr);
        }
        if (polygon3.length === 5) {
            polygon3.shift();
            const arr = polygon3.map(item => {
                return [item.x1 * 100 / width, item.y1 * 100 / height];
            });
            data1.push(arr);
        }
        const polygons = JSON.stringify(data1[0]);
        try {
            setIsLoading(true)
            let points = [];
            infoCropRegen?.forEach((shape, index) => {
                if (index > 0) {
                    points.push([shape?.x1 * 100 / width, shape?.y1 * 100 / height])
                }
            })
            const crop_region = JSON.stringify(points);
            const param = {
                cropRegion: crop_region,
                roiList: polygons,
                idCamDepartment: cameraCode,
                companyCode: companyOfCam?.company_code || "",
                companyName: companyOfCam?.company_name || "",
                serviceCode: "20230222000000000002"
            }
            await aiConfigFRS.editAiConfigRoiList(param);
            // if (!motionStatus) {
            //     await handleTurnOnMotion(cameraCode)
            // }
            Toast.open(`Cài đặt Nhận dạng khuôn mặt thành công`, 'success');
            setIsLoading(false);
            // setReGetData(!reGetData)
        } catch (error) {
            setIsLoading(false);
            // console.log(error);
            Toast.open('Cài đặt Nhận dạng khuôn mặt không thành công', 'danger');
        }
    }
    const handleChagePolygon = (value) => {
        setListPolygon(value)
    }
    const handleShowConfirmDefault = () => {
        setConfirmDefault(!confirmDefault)
    }
    const handleSetDefault = async () => {
        handleShowConfirmDefault()
        setCropRegion(0)
        await handleUpdate({
            polygon1: [],
            polygon2: [],
            polygon3: []
        }, [])
        setRefresh(!reFresh)
    }

    const handleCancel = () => {
        setRefresh(!reFresh)
        setIsLoading(true)
        setCropRegion(0)
        setListPolygon({
            polygon1: [],
            polygon2: [],
            polygon3: []
        })
        if (onClose) {
            onClose()
        }
    }

    const handleAccept = () => {
        handleUpdate(listPolygon, defaultShape)
    }
    const handleReFresh = () => {
        setCropRegion(0);
        setRefresh(!reFresh);
    }
    return (
        <>
            {confirmDefault && <Alert title={"Xác nhận cài lại mặc định"}
                onClose={handleShowConfirmDefault}
                onOk={handleSetDefault}
            />}
            <CanvasDraw
                polygon={listPolygon}
                onChange={handleChagePolygon}
                path={path}
                width={width}
                height={height}
                cropRegion={cropRegion}
                setCropRegion={(value) => setCropRegion(value)}
                defaultShape={defaultShape}
                setDefaultShape={(val) => setDefaultShape(val)}
                reFresh={handleReFresh}
            />
            <div className={cx('footer')}>
                <Button
                    title={t('setting.Reset_to_default')}
                    className={cx("btn-save")}
                    onClick={handleShowConfirmDefault}
                />
                <Button
                    title={t('stream.cancelCustom')}
                    className={cx("btn-cancle")}
                    onClick={handleCancel}
                />
                <Button
                    title={t('settingCam.Save_settings')}
                    className={cx("btn-save")}
                    onClick={handleAccept}
                />
            </div>
            {isLoading && <div className={cx('modal_loading')}><Loading /></div>}
        </>
    )
}

export default ConfigZone;